import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import api from "./lib/api";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import NFPAPage from "./pages/NFPAPage";
import MapPage from "./pages/MapPage";
import ForumPage from "./pages/ForumPage";
import ThreadPage from "./pages/ThreadPage";
import DirectoryPage from "./pages/DirectoryPage";
import TrainingPage from "./pages/TrainingPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    (async () => {
      if (sessionId) {
        try {
          const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
          setUser(data.user);
        } catch (e) {
          console.error("Google auth failed", e);
        }
      }
      window.history.replaceState({}, "", "/");
      navigate("/", { replace: true });
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="label-tech text-muted-foreground">Signing you in…</p>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/knowledge" element={<NFPAPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/forum" element={<ForumPage />} />
        <Route path="/forum/:threadId" element={<ThreadPage />} />
        <Route path="/directory" element={<DirectoryPage />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors offset="76px" toastOptions={{ duration: 2500 }} />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
